import { render } from "./SickBay.vue?vue&type=template&id=3fcd4334"
import script from "./SickBay.vue?vue&type=script&lang=js"
export * from "./SickBay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__